import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    // Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
Fade,
    Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const PartnerRepeatOrderList = () => {
    const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();
	const [branchidNo, setbranchidNo] =  useState(get_cookies('branchidno'));
	const [downloadFlag, setDownloadFlag] = useState(false);

	// Data Fetching
	useEffect(() => {
		//data();
		setDataLoaded(true);
	}, []);
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
            `${process.env.REACT_APP_API_URL}/repeat_order_list_report`, {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: branchidNo,  //branchidNo
            }
		}).then((res)=> {
			setDataLoaded(true);
			setPosts(res.data.data);
		}).catch((error)=>{
			setDataLoaded(true);
		//console.log(error.message);
		})
    }
    
    const data = async () => {
    };

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };
     
    const columns = [
			{
				name: "date",
				label: "Date",
				options: {
					filter: false,
					// display: "excluded", 
				},
			},
            {
                name: "refno",
                label: "Ref. No",
                options: {
                    filter: false,
                    // display: "excluded",
                },
            },
			{
                name: "name",
                label: "Name",
                options: {
                    filter: false,
                    // display: "excluded", 
                },
            },
            {
                name: "type",
                label: "Type",
                options: {
                    filter: false,
                    // display: "excluded",
                },
            },
			{
				name: "drno",
				label:"Actions",
				options: {
				  customBodyRender: (value, tableMeta, updateValue) => {
					//viewsoforcenter.php (drno)
					return (
						// <NavLink to={"/reports/repeat-order-list/payment-details/"+value}>
							<Button variant="contained" color="primary">
								View SO
							</Button>	
					//    </NavLink> 
					);
				  },download: false 
				}
			}
        ];

        const options = {
            filter: true,
            // filterType: "dropdown",
            selectableRows: "none",
            filterType: "multiselect",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                console.log(colIndex, colName, data);
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },    
			download: downloadFlag,  //add this
			print: downloadFlag, //add this
			downloadOptions: {
				filename : 'PartnerRepeatOrderList.csv' //change filename of csv
			}
            // tableBodyHeight,
		};
		
		const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<AssessmentTwoTone />
            				</div>
            				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
							<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
            				<h4 className="header-title">Partner Repeat Order List Report</h4>
            			</div>
            			<div className="page-container">
							<div style={style}>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={5} md={5} lg={3} xl={3}>
										<TextField
											id="outlined-basic"
											label="Select Date"
											variant="outlined"
											fullWidth={true}
											onFocus={() => setOpen(true)}
											autoComplete="off"
											value={`${format(
												dateRange.startDate,
												"MM/dd/yyyy"
											)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
										/>
										<DateRangePicker
											open={open}
											toggle={toggle}
											onChange={(range) => dateRangeHandler(range)}
										/> 
									</Grid>
									<Grid item xs={1} xl={1} style={{marginBlock: "auto"}}>
										<Button variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
									</Grid>
								</Grid>        
							</div>
							
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
            					<MUIDataTable
            						title={
            							<div>
            						
            								<div className="table-title">
            									Partner Repeat Order List Report
            								</div>
            							</div>
            						}
            						data={posts}
            						columns={columns}
            						options={options}
            					/>
            				)}
            			</div>
            		</div>
            	);
};

export default PartnerRepeatOrderList;